import { Snackbar, Alert } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { hideToaster } from '../../store/slices/toaster';
import React, { useEffect } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Toaster: React.FC = () => {
  const dispatch = useDispatch();
  const { open, message, type, duration } = useSelector((state: RootState) => state.toaster);

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        dispatch(hideToaster());
      }, duration ?? 1500);
      return () => clearTimeout(timer);
    }
  }, [open, dispatch, duration]);

  return (
    <Snackbar
      sx={{ zIndex: 9999 }}
      open={open}
      autoHideDuration={duration ?? 1500}
      onClose={() => dispatch(hideToaster())}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={() => dispatch(hideToaster())}
        icon={type === 'success' ? <CheckCircleIcon sx={{ color: '#17dc1a' }} /> : undefined}
        severity={type}
        sx={{
          backgroundColor: type === 'success' ? '#695ea8' : '#f6a9a9',
          color: '#ffffff',
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Toaster;
